import React from 'react'

import { LoadingPage } from './loading-page'

// Temporary component rendered while determining the actual default view
export const Default = () => <LoadingPage />
